// extracted by mini-css-extract-plugin
module.exports = {"navigation":"Navigation_navigation__jnWGr","row":"Navigation_row__kIIL_"};